const translationEn = {
  all_projects: "All Projects",
  create_project: "Create Project",
  unassigned: "Unassigned",
  warnign_alarm: "Warning/Alarm List",
  information: "Station Names",
  map: "Map",
  warnings: "Warning/Alarms",
  events: "Recordings",
  visualization: "Visualization",
  settings: "Settings",
  devices: "Devices",
  logout: "Logout",
  from: "From",
  to: "To",
  search: "Search",
  download_report: "Download Report",
  download_zip: "Download SEG2 Zip",
  list_view: "List View",
  slow_trace: "Slow Trace",
  histogram: "Histogram",
  norm: "Norm",
  date_time: "Date/Time",
  project: "Project",
  station: "Station",
  max: "Max",
  max_amplitudes: "Max Amplitudes",
  dom_frequencies: "DOM Frequencies",
  view_visualization: "View Visualization",
  view_details: "View Details",
  view_single_report: "View Single Report",
  download_seg2: "Download Seg2",
  visualization_for: "Visualization for ",
  trace: "Trace",
  absolute_time: "Absolute Time",
  relative_time: "Relative Time",
  event: "Event",
  project_name: "Project Name",
  station_name: "Station Name",
  new_station_name: "New Station Name",
  device_id: "Device ID",
  gps_position: "GPS Position",
  project_information: "Project Information",
  comment: "Comment",
  client: "Client",
  company: "Company",
  location: "Location",
  observer: "Observer",
  measurement_setting: "Measurement Setting",
  global_measurement_settings: "Global Measurement Settings",
  measurement_unit: "Measurement Unit",
  measurement_range: "Measurement Range",
  sampling_rate: "Sampling Rate ",
  trace_length: "Trace Length ",
  pretrigger_length: "Pretrigger Length ",
  measurement_gain: "Measurement Gain",
  offset_remover: "Offset Remover",
  microphone_channel: "Microphone Channel",
  measurement_type: "Measurement Type",
  trigger_level_X: "Trigger Level X",
  trigger_level_Y: "Trigger Level Y",
  trigger_level_Z: "Trigger Level Z",
  trigger_level_VR: "Trigger Level VR",
  auto_trigger_interval: "Auto Trigger Interval ",
  axis_auto_rotation: "Axis Auto Rotation",
  manual_rotation_X_axis: "Manual Rotation X Axis",
  manual_rotation_Y_axis: "Manual Rotation Y Axis",
  manual_rotation_Z_axis: "Manual Rotation Z Axis",
  background_trace: "Background / Slow Trace",
  next: "Next",
  previous: "Previous",
  global_device_messaging: "Global Device Messaging",
  sms_user_0_number: "Sms User [0] number",
  sms_user_1_number: "Sms User [1] number",
  sms_user_2_number: "Sms User [2] number",
  sms_user_3_number: "Sms User [3] number",
  sms_user_4_number: "Sms User [4] number",
  sms_user_5_number: "Sms User [5] number",
  email_user_0: "Email User [0]",
  email_user_1: "Email User [1]",
  email_user_2: "Email User [2]",
  email_user_3: "Email User [3]",
  email_user_4: "Email User [4]",
  email_user_5: "Email User [5]",
  warning_level: "Warning Level",
  alarm_level: "Alarm Level",
  sms_silence_time: "Sms Silence Time",
  message_on: "Message On",
  trigger: "Trigger",
  warning: "Warning",
  alarm: "Alarm",
  system: "System",
  weekly: "Weekly",
  monthly: "Monthly",
  global_server_messaging: "Global Server Messaging",
  data_transfer: "Data Transfer",
  global_transfer_settings: "Global Transfer Settings",
  data_transmission_network: "Data Transmission Network",
  let_apn: "LTE APN",
  wlan_ssid: "WLAN SSID",
  wlan_passkey: "WLAN Passkey",
  enable_ftp_upload: "Enable FTP/SFTP Upload",
  ftp_server: "FTP/SFTP Server",
  ftp_user: "FTP/SFTP User",
  ftp_password: "FTP/SFTP Password",
  gps_module_enabled: "GPS Module Enabled",
  led_signals: "LED Signals",
  network_data_url: "Network Data URL",
  network_data_ep: "Network Data EP",
  network_config_url: "Network Config Url",
  network_config_ep: "Network Config EP",
  network_config_ep_ack: "Network Config EP ACK",
  available_devices: "Available Devices",
  renting_from: "Renting From",
  renting_to: "Renting To",
  options: "Options",
  abort: "Abort",
  save: "Save",
  project_info: "Project Info",
  measurements: "Measurements",
  device_messaging: "Device Messaging",
  server_messaging: "Server Messaging",
  transfer_other: "Transfer/Other",
  assign_devices: "Assign Devices",
  serial_no: "Serial No.",
  user_details: "User Details",
  user_email: "User Email",
  language_setting: "Language Setting",
  timezone: "Timezone",
  summer_winter: "Summer / Winter",
  user_settings: "User Settings",
  save_user_settings: "Save User Settings",
  current_password: "Current Password",
  new_password: "New Password",
  confirm_new_password: "Confirm New Password",
  cancel: "Cancel",
  update_password: "Update Password",
  sub_accounts: "Sub Accounts",
  sub_account_permissions: "Sub Account and Permissions",
  login_name: "Login Name",
  other_information_available: "Other Information Available",
  permission: "Permissions",
  projects: "Projects",
  add_edit_users: "Add/Edit Users",
  add_edit_projects: "Add/Edit Projects",
  assign_projects: "Assign Projects",
  project_permissions: "Project Permissions",
  edit_devices: "Edit Devices",
  create_reports: "Create Reports",
  view_data: "View Data",
  showing: "Showing",
  file_downloaded: "The file is being downloaded, please wait",
  device_detail: "Device Details",
  network_name: "Network Name",
  start_time: "Start Time",
  end_time: "End Time",
  firmware_version: "Firmware Version",
  current_pass_error: "Please enter current password!",
  current_pass_no_find: "Current password isn't correct!",
  new_pass_error: "Please enter new password!",
  confirm_pass_error: "Please enter confirm password!",
  pass_no_match: "New Password and confirm password doesn't match!",
  add_edit: "Add/Edit",
  users: "Users",
  edit: "Edit",
  reports: "Reports",
  create: "Create",
  view: "View",
  data: "Data",
  project_field: "Please fill project name field",
  server_messaging_setting: "Server Messaging Settings",
  email_silence_time: "Email Silence Time",
  automatic_report: "Automatic Report On",
  assigned_device: "Assigned Devices",
  assign: "Assign",
  attention: "ATTENTION",
  attention_message:
    "If the project is saved, all the global settings with be transferred to the assigned devices and device configuration with be updated",
  all_available_devices: "All Available Devices",
  event_report: "Event Report",
  compliance_report: "Compliance Report",
  measurement_information: "Measurement Information",
  channel_name: "Channel Name",
  maxima: "Maxima",
  time_maxima: "Time of Maxima",
  frequency: "Frequency",
  peak_displacement: "Peak Displacement",
  peak_acceleration: "Peak Acceleration",
  download_event_list: "Download with Events List",
  downlaod_without_event_list: "Download without Events List",
  fname: "First Name",
  lname: "Last Name",
  username: "Username",
  email: "Email",
  password: "Password",
  confirm_password: "Confirm Password",
  fname_error: "Please enter first name",
  lname_error: "Please enter Last name",
  email_error: "Please enter Email",
  username_error: "Please enter User name",
  password_error: "Please enter Password",
  confirm_password_error: "Please enter Confirm Password",
  password_match_error: "Password and Confirm Password not match",
  role_error: "Please select atleast one user role",
  username_email_found: "The username or email already exists",
  view_report: "View Report",
  select_event: "Select Events",
  select_project: "Select Project",
  device_deleted: "The selected device has been deleted from the project!",
  something_wrong: "Something went wrong. Please try later!",
  project_created:
    "The project has been created and the devices have been assigned!",
  project_updated:
    "The project has been updated and the devices have been assigned!",
  session_expired: "Session Expired",
  session_expired_message: "Your session has expired please login again",
  station_name_exist: "Station Name already exists!",
  station_name_empty: "Please provide Station Name",
  assign_project_setting: "Assign the project settings?",
  project_deleted: "The project has been deleted!",
  yes: "Yes",
  no: "No",
  project_select:
    "Please select project that needs to be assigned to the selected device",
  device_assigned: "The device is assigned to the selected project",
  delete_dialoge_message: "Do you want to delete this device with id",
  delete_confirmation: "Delete Confirmation",
  device_updated: "The device has been updated",
  slow_trace_graph: "Slow Trace Graph",
  relative_timein: "Relative Time in",
  project_delete_message: "Do you want to delete the project named",
  correct_date: "Please select correct date and time range",
  download_csv: "Export to CSV",
  setting_updated: "The user settings has been updated!",
  power_save: "Power Save",
  traceLength_error: "Please fill the trace length field",
  pretriggerLength_error: "Please fill the pre trigger length field",
  triggerX_error: "TriggerX can't be 0 or less than 0",
  triggerY_error: "TriggerY can't be 0 or less than 0",
  triggerZ_error: "TriggerZ can't be 0 or less than 0",
  autoTrigger_error: "Auto Trigger should atleast be 0",
  samplingRate_error: "Please select sampling rate",
  slow_trace_error: "Please provide slow trace",
  microphone_error: "Please select microphone channel",
  powersave_error: "Please select power save",
  projectName_error: "Please fill project name field",
  norm_error: "Please fill norm field",
  graphical_overview: "Graphical overview of events on a time basis.",
  tracelength_greater_error:
    "Trace Length should be greater than Pretrigger length",
  last_day: "24 Hours",
  last_week: "Last 7 Days",
  last_10_days: "Last 10 Days",
  last_14_days: "Last 14 Days",
  last_month: "Last 1 Month",
  last_2_month: "Last 2 Month",
  project_cancelled: "Settings has been cancelled",
  deleted_project: "Deleted Projects",
  restore_project_header: "Restore Project",
  restore_project: "Do you want to restore the following project",
  restore_project_message: "The project has been restored",
  email_check: "Please check your email for the download link",
  slow_trace_report: "Slow Trace Report",
  date: "Data",
  data_station: "Please select station name having data",
  update_station: "Update Station",
  current_station_name: "Current Station",
  new_station: "New Station",
  station_updated: "The Station has been updated",
  station_name_error: "Please fill station name field",
  station_name_special_char_error:
    "Please don't use special characters in station name",
  sms0_error: "Please fill sms 0 Number Field",
  sms1_error: "Please fill sms 1 Number Field",
  sms2_error: "Please fill sms 2 Number Field",
  sms3_error: "Please fill sms 3 Number Field",
  sms4_error: "Please fill sms 4 Number Field",
  sms5_error: "Please fill sms 5 Number Field",
  email0_error: "Please fill email 0 Number Field",
  email1_error: "Please fill email 1 Number Field",
  email2_error: "Please fill email 2 Number Field",
  email3_error: "Please fill email 3 Number Field",
  email4_error: "Please fill email 4 Number Field",
  email5_error: "Please fill email 5 Number Field",
  item_selected: "items selected",
  change_slow_trace: "Change to Slow Trace Graph",
  change_bar_graph: "Change to Bar Graph",
  linear: "Linear Scale",
  logarithmic: "Logarithmic Scale",
  select_norm: "Select Norm",
  no_data: "There's no available data",
  project_exist: "Project Name already exists",
  trigger_level: "Trigger Level",
  vector_sum: "Vector Sum",
  previous_event: "Previous Event",
  next_event: "Next Event",
  delete: "Delete",
  lte_apn_error: "Please fill LTE APN field",
  data_url_error: "Please fill data Url field",
  data_ep_error: "Please fill data Ep field",
  config_url_error: "Please fill config Url field",
  config_ep_error: "Please fill config EP field",
  config_ep_ack_error: "Please fill config EP ACK field",
  field_name: "Field Name",
  input: "Input",
  communication_param: "Communication parameters",
  ftp_option: "Optional FTP/SFTP Data Transfer",
  cloud_stand: "Cloud Access Data",
  gps_settings: "GPS Settings",
  custom_time: "Custom Time",
  din_plot: "DIN Plot Graph",
  traceLength_limit_error:
    "Trace Length should be greater than equal to 10[s] and less than equal to 120[s]",
  preTriggerLength_limit_error:
    "Pre Trigger Length should be greater than equal to 0[s] and less than equal to 119[s]",
  in_progress: "In Development",
  warning_error: "Warning Level Should be less than Alarm Level",
};
export default translationEn;
